<template>
  <div class="page-bg">
    <section class="login-page-container">
      <div class="login-container">
        <div class="system-title">
          <img src="/logo.png" class="system-logo" />
          <span class="system-name">项目文档管理系统</span>
        </div>
        <p class="system-introduction">请填写账户注册信息并提交管理员审核</p>
        <div class="login-form">
          <p class="section-title">账户注册</p>
          <a-input v-model="registerForm.partnerName" type="text" size="large" placeholder="资源合作方名称" class="login-input" >
            <a-icon slot="prefix" type="user" />
          </a-input>
          <a-input v-model="registerForm.realName" type="text" size="large" placeholder="真实姓名" class="login-input" >
            <a-icon slot="prefix" type="user" />
          </a-input>
          <a-input v-model="registerForm.mobile" type="text" size="large" placeholder="手机号" class="login-input" >
            <a-icon slot="prefix" type="mobile" />
          </a-input>
          <a-input-password v-model="registerForm.passwd" size="large" placeholder="至少6位,包含字母和非字母字符" class="login-input" >
            <a-icon slot="prefix" type="key" />
          </a-input-password>
          <a-input-password v-model="registerForm.confirmPwd" size="large" placeholder="确认密码" class="login-input" >
            <a-icon slot="prefix" type="key" />
          </a-input-password>
          <div class="input-comp">
            <a-input
                v-model="registerForm.captcha"
                placeholder="请输入验证码"
                :max-length="4"
                size="large"
                class="code-input"
            >
              <a-icon slot="prefix" type="safety-certificate" />
            </a-input>
            <img
                :src="captchaImgUrl"
                alt="验证码"
                class="captcha-img"
                @click="refreshCaptcha"
            />
          </div>
          <div class="action-box">
            <a-button
                type="primary"
                @click="handleSubmit"
                :loading="loginLoading"
                class="register-btn"
            >
              注册
            </a-button>
            <a-button type="link" @click="onLogin" class="right-btn">使用已有账户登录</a-button>
          </div>
        </div>
      </div>

      <div class="footer">
        迪坤新能源（江苏）有限公司 版权所有 @2024 build.v2.2410252226
      </div>
    </section>
  </div>
</template>
<script>
import { baseURL } from "@/services/HttpService";
import { registerUser } from "@/services/LoginService";

export default {
  data() {
    return {
      registerForm: {
        partnerName: "",
        realName: "",
        mobile: "",
        passwd: "",
        confirmPwd: "",
        verifyCode: "",
      },
      captchaImgUrl: `${baseURL}/captchaImg?tm=${new Date().getTime()}`,
      errMsg: "",
      loginLoading: false,
      url: process.env.VUE_APP_API_HOST,
    };
  },
  methods: {
    // 刷新验证码
    refreshCaptcha: function () {
      this.captchaImgUrl = `${baseURL}/captchaImg?tm=${new Date().getTime()}`;
      this.registerForm.verifyCode = "";
    },
    handleSubmit() {
      if (this.registerForm.partnerName === "") {
        this.$message.warning('请输入资源合作方名称');
        return;
      }
      if (this.registerForm.realName === "") {
        this.$message.warning('请输入真实姓名');
        return;
      }
      if (this.registerForm.mobile === "") {
        this.$message.warning('请输入手机号');
        return;
      }
      if (this.registerForm.passwd === "") {
        this.$message.warning('请输入密码');
        return;
      }
      if (this.registerForm.passwd.length < 6 || !/[a-zA-Z]/.test(this.registerForm.passwd) || /^[a-zA-Z]+$/.test(this.registerForm.passwd)) {
        this.$message.warning('密码至少6位，且包含字母和非字母字符');
        return;
      }
      if (this.registerForm.passwd !== this.registerForm.confirmPwd) {
        this.$message.warning('两次密码输入不一致');
        return;
      }
      if (this.registerForm.captcha === "") {
        this.$message.warning('请输入验证码');
        return;
      }
      this.loginLoading = true;
      registerUser(this.registerForm)
        .then((resp) => {
          this.loginLoading = false;
          if (resp.data.code === "SUCCESS") {
            this.$message.success('注册成功，请等待管理员审核');
            this.$router.push({ name: "Login" });
          } else {
            this.errMsg = resp.data.errorMsg;
            this.refreshCaptcha();
          }
        })
        .catch(() => {
          this.loginLoading = false;
        });
    },
    onLogin() {
      this.$router.push({ name: "Login" });
    },

  }
}
</script>
<style scoped lang="less">
.page-bg {
  height: 100vh;
  background-color: white;
}
.login-page-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: url(../assets/white-bg.svg) no-repeat center center;
}
.login-container {
  flex-grow: 1;
}
.system-logo {
  width: 34px;
  height: 34px;
}
.system-title {
  width: 400px;
  margin-top: 136px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.system-name {
  color: rgba(0, 0, 0, 0.88);
  padding-left: 10px;
  font-weight: bold;
  font-size: 32px;
}
.system-introduction {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 40px;
  color:  rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
.login-form {
  width: 360px;
  margin-left: auto;
  margin-right: auto;
}
.login-input {
  border-radius: 10px;
  margin-bottom: 24px;
}
.input-comp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: 48px;
}
.code-input {
  width: 288px;
}
.captcha-img {
  height: 38px;
}
.action-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.register-btn {
  padding-left: 50px;
  padding-right: 50px;
}
.right-btn {
  padding-right: 0;
}
.section-title {
  font-size: 16px;
  font-weight: 500;
}
.footer {
  height: 50px;
  color:  rgba(0, 0, 0, 0.65);
  font-size: 14px;
  text-align: center;
}
</style>